"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialReportResponseDto = exports.FinancialReportDoctorItem = void 0;
const class_validator_1 = require("class-validator");
const property_1 = require("../../../decorators/property");
class FinancialReportDoctorItem {
}
exports.FinancialReportDoctorItem = FinancialReportDoctorItem;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], FinancialReportDoctorItem.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], FinancialReportDoctorItem.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportDoctorItem.prototype, "shareAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportDoctorItem.prototype, "settledAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportDoctorItem.prototype, "unSettledAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportDoctorItem.prototype, "totalAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportDoctorItem.prototype, "refundedAmount", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)(),
    __metadata("design:type", Array)
], FinancialReportDoctorItem.prototype, "receiptIds", void 0);
class FinancialReportResponseDto {
}
exports.FinancialReportResponseDto = FinancialReportResponseDto;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "totalAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "totalPaidByUsers", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "totalDoctorShare", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "totalDiscounts", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "totalRefundedAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "unsettledAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "settledAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], FinancialReportResponseDto.prototype, "companyShare", void 0);
__decorate([
    (0, property_1.Property)({ type: () => [FinancialReportDoctorItem] }),
    __metadata("design:type", Array)
], FinancialReportResponseDto.prototype, "doctors", void 0);
